import { type GenericDetailQueryKey, generateDetailQueryKey } from '@pba/react-query';
import { cohortsFeatureKey } from '../list-query';

type CohortDetailQueryType = GenericDetailQueryKey;

export const getCohortDetailQueryKey = generateDetailQueryKey({
  prefix: cohortsFeatureKey,
})<CohortDetailQueryType>;
